//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button'
import Card from '@/components/Register/components/Card.vue'
import { FormSelect, FormDatePicker } from '@/components/Form'
import GENRES from '@/constants/user-genres'
import EDUCATION_LEVELS from '@/constants/education-levels'
import ModalPolicyData from '~/components/PolicyData/ModalPolicyData'
import ModalPrivacyPolicy from '~/components/PolicyData/ModalPrivacyPolicy.vue'

export default {
  name: 'SetPersonalData',
  middleware: ['user-validate'],
  components: {
    Card,
    Button,
    FormDatePicker,
    FormSelect,
    ModalPolicyData,
    ModalPrivacyPolicy,
  },
  props: {
    phase: {
      type: String,
      default: '0',
    },
    form: {
      type: Object,
      default: () => ({
        identification_number: '12.312.312-3',
        names: 'Saul',
        lastnames: 'Galan',
        email: '',
        phone: '',
        birthdate: null,
        gender: {},
        education_level: {},
        terms: false,
      }),
    },
    setValue: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      regions: [],
      communes: [],
      modal: {
        policyData: false,
        privacyPolicy: false,
      },
      genders: [
        {
          id: GENRES.MALE,
          name: 'Masculino',
        },
        {
          id: GENRES.FEMALE,
          name: 'Femenino',
        },
        {
          id: GENRES.OTHERS,
          name: 'Otros',
        },
        {
          id: GENRES.NOT_SPECIFIED,
          name: 'Prefiero no decirlo',
        },
      ],
      educationLevels: [
        {
          id: EDUCATION_LEVELS.BASIC,
          name: 'Educación básica',
        },
        {
          id: EDUCATION_LEVELS.MEDIUM,
          name: 'Educación media (Técnica Profesional y Científico-Humanista)',
        },
        {
          id: EDUCATION_LEVELS.HIGHER,
          name:
            'Educación superior (Centro de Formación Técnica, Institutos Profesionales, Universidades)',
        },
        {
          id: EDUCATION_LEVELS.POSTGRADUATE,
          name: 'Postgrado (Diplomados, Maestrías o Doctorados)',
        },
      ],
    }
  },
  computed: {
    date14YearsAgo() {
      const d = new Date()
      d.setFullYear(d.getFullYear() - 14)
      return d
    },
  },
  watch: {
    form: {
      handler() {
        this.form.email = this.form.email.toLowerCase()
      },
      deep: true,
    },
  },
  methods: {
    submit() {
      this.$emit('setValue', this.form)
    },
    async selectRegion(selectOption) {
      this.loading = true
      const parentCodes = selectOption?.children?.map(({ id }) => id)
      this.communes = await this.$repository.location.find({
        parent_in: parentCodes,
        type: 'comuna',
        _sort: 'name:ASC',
      })
      this.loading = false
      this.$forceUpdate()
    },
    togglePolicyDataModal() {
      this.modal.policyData = !this.modal.policyData
    },
    togglePrivacyPolicyModal() {
      this.modal.privacyPolicy = !this.modal.privacyPolicy
    },
  },
}
